import { 
    Button, 
    Divider, 
    Flex, 
    Modal, 
    ModalBody, 
    ModalCloseButton, 
    ModalContent, 
    ModalFooter, 
    ModalHeader, 
    ModalOverlay,
    Text,  
} from "@chakra-ui/react";
import { useState } from "react";
import { Select } from "../../components/Forms/Select";
import { useContestation } from "../../hooks/useContestation";
import { DisputeModel } from "../../models/Dispute";
import { InformationIcon } from "../../styles/icons/InformationIcon";
import { formatCurrency, formatDate, showToast } from "../../utils";

interface CreateTransferModalProps {
    isOpen: boolean;
    onClose: () => void;
    selectedDispute: DisputeModel;
}


export function DetailsModal({ 
    isOpen, 
    onClose,  
    selectedDispute
}: CreateTransferModalProps) {
    const [isLoading, setIsLoading] = useState(false);
    const { putDisputeCharge, putChargeStatus } = useContestation();
    const [section, setSection] = useState(1);
    const [selectedChargebackStatus, setSelectedChargebackStatus] = useState("REFUND");
    const phaseOptions = [
        {
            name: 'Contato com buyer',
            value: 'IN_CONTACT_WITH_BUYER'
        },
        {
            name: 'Contato com seller',
            value: 'IN_CONTACT_WITH_SELLER'
        },
        {
            name: 'Aguardando buyer',
            value: 'AWAITING_BUYER_RESPONSE'
        },
        {
            name: 'Aguardando seller',
            value: 'AWAITING_SELLER_RESPONSE'
        },
        {
            name: 'Aguardando provedor',
            value: 'AWAITING_PROVIDER_RESPONSE'
        },
    ]
    const motiveOptions = [
        {
            name: 'Fraude',
            value: 'FRAUD'
        },
        {
            name: 'Autofraude',
            value: 'AUTOFRAUD'
        },
        {
            name: 'Desacordo comercial',
            value: 'COMMERCIAL_DISAGREEMENT'
        },
        {
            name: 'Outros',
            value: 'OTHERS'
        },
    ]
    const statusOptions = [
        {
            name: 'Estorno',
            value: 'REFUND',
            color: '#D46B08'
        },
        {
            name: 'Chargeback',
            value: 'CHARGEBACK',
            color: '#A8071A'
        },
        {
            name: 'Pago',
            value: 'PAID',
            color: '#389E0D'
        },
    ]
    const handleChangePhase = async (id: string, value: string) => {
        const disputeFormData = {
            disputeStageStatus: value,
            reasonType: selectedDispute?.reasonType ?? "OTHERS",
            otherReason: ""
        }
        await putDisputeCharge(id, disputeFormData)
    }

    const handleChangeMotive = async (id: string, value: string) => {
        const motiveFormData = {
            disputeStageStatus: selectedDispute?.disputeStageStatus ?? "IN_CONTACT_WITH_BUYER",
            reasonType: value,
            otherReason: ""
        }
        await putDisputeCharge(id, motiveFormData)
    }
    async function onSubmit(data: any) {
        try {
            setIsLoading(true);
            const chargeStatusData = {
                status: selectedChargebackStatus,
                uuidCharge: selectedDispute?.uuidCharge,
            }
            await putChargeStatus(chargeStatusData)
            showToast({
                message: "Chargeback finalizado com sucesso!",
                type: "success",
            });
        } catch (error) {
            //@ts-ignore
            error?.response?.data?.errors.map((error) => {
                return  showToast({
                            type: "error",
                            message: `${error?.code} - ${error?.description}`
                        })
            });
        } finally {
            setIsLoading(false);
            setSelectedChargebackStatus("REFUND")
            onClose();
        }
    }
    return (
        <Modal 
            isOpen={isOpen} 
            onClose={onClose}
        >
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>
                        {section === 1 && (
                            <Flex 
                                w="100%" 
                                maxH={56} 
                                align="center"
                                gap="2"
                            >
                                <InformationIcon
                                    size={25} 
                                /> 
                                <Text>Dados da contestação</Text>
                                <ModalCloseButton />
                            </Flex>
                        )}
                        {section === 2 && (
                            <Flex 
                                w="100%" 
                                maxH={56} 
                                align="center"
                                gap="2"
                            >
                                <Text>Finalizar chargeback?</Text>
                                <ModalCloseButton />
                            </Flex>
                        )}
                    </ModalHeader>
                    <ModalBody p="24px">
                    {section === 1 && (
                        <>
                            <Flex 
                                w="100%" 
                                direction="column" 
                                gap="2"
                            >
                                <Text fontWeight={700}>Chargeback</Text>
                                <Flex
                                    align="center"
                                    gap="50px"
                                >
                                    <Text w="90px">Fase</Text>
                                    <Select
                                        maxW="250px"
                                        name="phase"
                                        onChange={(e) => {
                                            handleChangePhase(selectedDispute?.uuidCharge, e.currentTarget.value)
                                        }}
                                        defaultValue={selectedDispute?.disputeStageStatus}
                                    >
                                        {phaseOptions?.map((op, index) => <option key={index} value={op.value}>{op.name}</option>)}
                                    </Select>
                                </Flex>
                                <Flex
                                    align="center"
                                    gap="50px"
                                >
                                    <Text w="90px">Motivo</Text>
                                    <Select 
                                        maxW="250px"
                                        name="motive"
                                        defaultValue={selectedDispute?.reasonType}
                                        onChange={(e) => {
                                            handleChangeMotive(selectedDispute?.uuidCharge, e.currentTarget.value)
                                        }}
                                    >
                                        {motiveOptions?.map((op, index) => <option key={index} value={op.value}>{op.name}</option>)}
                                    </Select>
                                </Flex>
                                <Flex
                                    align="center"
                                    gap="25px"
                                >
                                    <Text w="90px">Data limite</Text>
                                    <Text>{formatDate(selectedDispute?.contestationDeadline)}</Text>
                                </Flex>
                            </Flex>
                            <Divider my="12px"/>
                            <Flex 
                                w="100%" 
                                direction="column" 
                                gap="2"
                                fontSize="14px"
                            >
                                <Text fontWeight={700}>Pagamento</Text>
                                <Flex
                                    align="center"
                                    gap="25px"
                                >
                                    <Text w="90px">Cód Aut</Text>
                                    <Text>{selectedDispute?.authorizationCode}</Text>
                                </Flex>
                                <Flex
                                    align="center"
                                    gap="25px"
                                >
                                    <Text w="90px">NSU</Text>
                                    <Text>{selectedDispute?.authorizationNsu}</Text>
                                </Flex>
                                <Flex
                                    align="center"
                                    gap="25px"
                                >
                                    <Text w="90px">Trans ID</Text>
                                    <Text>{selectedDispute?.integrationId}</Text>
                                </Flex>
                                <Flex
                                    align="center"
                                    gap="25px"
                                >
                                    <Text w="90px">Provedor</Text>
                                    <Text>{selectedDispute?.sellerName}</Text>
                                </Flex>
                            </Flex>
                            <Divider my="12px"/>
                            <Flex 
                                w="100%" 
                                direction="column" 
                                gap="2"
                                fontSize="14px"
                            >
                                <Text fontWeight={700}>Charge</Text>
                                <Flex
                                    align="center"
                                    gap="25px"
                                >
                                    <Text w="90px">Título</Text>
                                    <Text>{selectedDispute?.title}</Text>
                                </Flex>
                                <Flex
                                    align="center"
                                    gap="25px"
                                >
                                    <Text w="90px">ID cobrança</Text>
                                    <Text>{selectedDispute?.uuidCharge}</Text>
                                </Flex>
                                <Flex
                                    align="center"
                                    gap="25px"
                                >
                                    <Text w="90px">Valor</Text>
                                    <Text>{formatCurrency({value: selectedDispute?.value})}</Text>
                                </Flex>
                                <Flex
                                    align="center"
                                    gap="25px"
                                >
                                    <Text w="90px">Pagamento</Text>
                                    <Text>{formatDate(selectedDispute?.paidDate)}</Text>
                                </Flex>
                            </Flex>
                            <Divider my="12px"/>
                            <Flex 
                                w="100%" 
                                direction="column" 
                                gap="2"
                                fontSize="14px"
                            >
                                <Text fontWeight={700}>Seller</Text>
                                <Flex
                                    align="center"
                                    gap="25px"
                                >
                                    <Text w="90px">Seller ID</Text>
                                    <Text>{selectedDispute?.authorizationCode}</Text>
                                </Flex>
                                <Flex
                                    align="center"
                                    gap="25px"
                                >
                                    <Text w="90px">Nome</Text>
                                    <Text>{selectedDispute?.sellerName}</Text>
                                </Flex>
                            </Flex>
                            <Divider my="12px"/>
                            <Flex 
                                w="100%" 
                                direction="column" 
                                gap="2"
                                fontSize="14px"
                            >
                                <Text fontWeight={700}>Cliente</Text>
                                <Flex
                                    align="center"
                                    gap="25px"
                                >
                                    <Text w="90px">Nome</Text>
                                    <Text>{selectedDispute?.customerName}</Text>
                                </Flex>
                                <Flex
                                    align="center"
                                    gap="25px"
                                >
                                    <Text w="90px">Documento</Text>
                                    <Text>{selectedDispute?.customerDocument}</Text>
                                </Flex>
                                <Flex
                                    align="center"
                                    gap="25px"
                                >
                                    <Text w="90px">Email</Text>
                                    <Text>{selectedDispute?.customerEmail}</Text>
                                </Flex>
                                <Flex
                                    align="center"
                                    gap="25px"
                                >
                                    <Text w="90px">Telefone</Text>
                                    <Text>{selectedDispute?.customerPhone}</Text>
                                </Flex>
                            </Flex>
                        </>
                    )}
                    {section === 2 && (
                        <Flex 
                            w="100%" 
                            direction="column" 
                            gap="2"
                        >
                            <Text 
                                fontSize="16px"
                            >
                                Selecione o status final do chargeback
                            </Text>
                            <Select
                                name="status"
                                color={statusOptions?.filter(so => so.value === selectedChargebackStatus)[0]?.color}
                                onChange={(e) => setSelectedChargebackStatus(e.currentTarget.value)}
                                value={selectedChargebackStatus}
                            >
                                {statusOptions?.map((op, index) => <option style={{color: op.color}}key={index} value={op.value}>{op.name}</option>)}
                            </Select>
                        </Flex>
                    )}
                    </ModalBody>
                    <ModalFooter p="24px">
                            <Flex
                                w="100%" 
                                direction="column" 
                                gap="2"
                                as="form"
                            >
                            </Flex>
                    </ModalFooter>
                    <Flex 
                        w="100%" 
                        borderTop="1px solid" 
                        borderColor="gray.50"
                        p="2"
                        justifyContent="flex-end"
                        gap="2"
                    >
                        {section === 1 && (
                            <>
                                <Button  
                                    variant="secondary"
                                    onClick={onClose}
                                >
                                    Voltar
                                </Button>
                                <Button 
                                    variant="primary"
                                    type="button"
                                    isLoading={isLoading}
                                    onClick={() => setSection(2)}
                                >
                                    Finalizar chargeback
                                </Button>
                            </>
                        )}
                        {section === 2 && (
                            <>
                                <Button  
                                    variant="secondary"
                                    onClick={() => setSection(1)}
                                >
                                    Cancelar
                                </Button>
                                <Button 
                                    variant="primary"
                                    type="button"
                                    isLoading={isLoading}
                                    onClick={onSubmit}
                                >
                                    Finalizar chargeback
                                </Button>
                            </>
                        )}
                    </Flex>
                </ModalContent>
            </Modal>
    )
}